import { Injectable } from '@angular/core';
import { NavigationProvider } from '@nrwl/navigation-abstract';

@Injectable({
  providedIn: 'root'
})
export class AnomalyLaunchDrilldownService {
  constructor(private readonly navigator: NavigationProvider) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  launchDrillDown(anomaly: any) {
    const kpiName = anomaly.kpiName || anomaly.item.kpiName;
    switch (kpiName) {
      case 'bytecount2to1':
      case 'bytecount':
        this.navigator
          .addRootParam('anomaly_clicked', anomaly)
          .navigateToPage(['byte-count-anomaly']);
        break;
      case 'mosaudioaverage':
      case 'mosvideoaverage':
        this.navigator.addRootParam('anomaly_clicked', anomaly).navigateToPage(['vcqav']);
        break;
      case 'callsetupduration':
        this.navigator.addRootParam('anomaly_clicked', anomaly).navigateToPage(['vcsdav']);
        break;
      case 'appdelayin':
      case 'appdelayout':
        this.navigator.addRootParam('triage_clicked', anomaly).navigateToDashboard(['triage']);
        break;
      case 'networkdelay':
        this.navigator.addRootParam('triage_clicked', anomaly).navigateToDashboard(['triage']);
        break;
      case 'eueserverscore':
      case 'euenetworkscore':
      case 'eueclientscore':
      case 'eueapplicationscore':
        this.navigator.addRootParam('triage_clicked', anomaly).navigateToDashboard(['triage']);
        break;
      case 'packetcount2to1':
      case 'packetcount1to2':
      case 'packetcount':
        this.navigator
          .addRootParam('anomaly_clicked', anomaly)
          .navigateToPage(['packet-count-anomaly']);
        break;
      default:
        if (anomaly.category === 'activetest') {
          this.navigator
            .addRootParam('anomaly_clicked', anomaly)
            .navigateToDashboard(['activetest-anomaly-drilldown'], {
              queryParams: {
                layeredSource: [anomaly.label, anomaly.englishDesc],
                queryParamsHandling: 'merge',
                replaceUrl: true
              }
            });
        }
    }
  }
}
